import script from "./ChatPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatPrompt.vue?vue&type=script&setup=true&lang=js"

import "./ChatPrompt.vue?vue&type=style&index=0&id=4ce9f836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ce9f836"]])

export default __exports__